import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useDayTick } from 'record-it-components/hooks/useDayTick';
import { useFunctionResult } from 'record-it-components/hooks/useFunctionResult/useFunctionResult';
import { EntityName } from 'record-it-time-common/EntityName';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { WorkTimeEntry } from '../../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { useCurrentUser } from '../../../useCurrentUser';
import { useEntityChangedListener } from '../../useEntityChangedListener/useEntityChangedListener';
import { useEntityRepository } from '../../useEntityRepository';
export function useTodaysWorkTimeEntries() {
  const $ = _c(6);
  const repository = useEntityRepository(EntityName.WorkTimeEntry);
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] !== currentUser || $[1] !== repository) {
    t0 = () => {
      if (!currentUser) {
        return [];
      }
      const entries = repository.getInDateRangeForUser({
        start: DateUtils.withCurrentTimezone().getStartOfDay(new Date()),
        end: DateUtils.withCurrentTimezone().getEndOfDay(new Date()),
        userId: currentUser.id
      });
      return entries.sort(_temp);
    };
    $[0] = currentUser;
    $[1] = repository;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const wrappedFunction = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== wrappedFunction) {
    t2 = {
      func: wrappedFunction,
      funcArgs: t1,
      resultsAreEqual: _temp2
    };
    $[4] = wrappedFunction;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    result,
    update
  } = useFunctionResult(t2);
  useEntityChangedListener(EntityName.TimeTrackingActivity, update);
  useDayTick(update);
  return result;
}
function _temp2(a_0, b_0) {
  return ArrayUtils.areShallowEqual(a_0, b_0);
}
function _temp(a, b) {
  return a.startDate.localeCompare(b.startDate);
}